export enum FleetUUIDs {
  ACTransit = '872a8e92-54b5-47b3-90a3-1210ab274d97',
  Barcelona = 'b2d1a097-8e9b-4655-abff-1bcb5c91c898',
  MTA = '4e9c24c6-489f-4f2c-9f10-5ab265c2e3d2',
  SacRTBusStopShelter = 'c2170fe9-d566-4e6b-a5d0-1a097d7b24fa',
  VanTesting = 'e64ba1c4-adb4-45b0-b351-180710e6cc67',
}
